import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const FooterWrapper = styled.footer`
`

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 48px;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 40px;
  }
`

export const FooterBrand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FooterLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const FooterLogo = styled.img`
  height:4rem;
  @media (max-width: 890px) {
    height: 5rem;
  }
`

export const FooterContact = styled.div`
  p {
    font-size: 16px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 16px;

    br {
      margin-bottom: 8px;
    }

    &::first-line {
      font-size: 18px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.9);
    }
  }
`

export const FooterLinks = styled.div`
  display: flex;
  gap: 32px;

  a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #FFFFFF;
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 16px;
  }
`

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
`

export const Copyright = styled.div`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
`

export const PrivacyLink = styled(Link)`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #FFFFFF;
  }
`